export default async function getToken() {
    return window.firebase.auth().currentUser.getIdToken();
}
